/* 08 お品書き（2026-10-02）：木札を選ぶと下の札が切り替わる（タブ）。左右キーでも選べる。
   画面に入ったら、札が掛かるように揺れて出る。そのあと選ばれていない札が1回だけ小さく揺れる（まだ触っていなければ）。
   選んでいる札から下の札へ、点線と三角でつなぐ（スマホは下の札の上辺、タブレット・PCは右の札の左辺）。
   動きを減らす設定では揺れなし（線と三角は出す）。カートに入れるのは kz-buy.js。 */
(() => {
  const init = (sec) => {
    if (sec.dataset.ks8On) return;
    sec.dataset.ks8On = '1';
    const tags = [...sec.querySelectorAll('.ks8__tag')];
    const cards = [...sec.querySelectorAll('.ks8__card')];
    if (!tags.length) return;
    const panel = sec.querySelector('.ks8__panel');
    const cardsEl = sec.querySelector('.ks8__cards');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let touched = false;

    /* 札と下の札をつなぐ線と三角 */
    const NS = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'ks8__link');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS(NS, 'path');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke-width', '1.2');
    path.setAttribute('stroke-dasharray', '3 4');
    const tri = document.createElementNS(NS, 'polygon');
    svg.append(path, tri);
    if (panel && cardsEl) panel.appendChild(svg);
    const draw = () => {
      if (!panel || !cardsEl || !svg.isConnected) return;
      const tag = tags.find((t) => t.classList.contains('is-on'));
      if (!tag || !cardsEl.offsetParent) return;
      const P = panel.getBoundingClientRect();
      const ox = P.left + panel.clientLeft;
      const oy = P.top + panel.clientTop;
      const T = tag.querySelector('.ks8__tagface').getBoundingClientRect();
      const C = cardsEl.getBoundingClientRect();
      const tone = getComputedStyle(tag).getPropertyValue('--tone').trim() || '#b8543e';
      const x1 = T.left + T.width / 2 - ox;
      const y1 = T.bottom - oy + 6;
      let d;
      let pts;
      if (C.top > T.bottom + 8) {
        /* 下の札が下にある（スマホ）：上辺に上向きの三角 */
        const x = Math.min(Math.max(x1, C.left - ox + 20), C.right - ox - 20);
        const y2 = C.top - oy;
        d = x === x1 ? `M${x1} ${y1} V${y2 - 9}` : `M${x1} ${y1} V${(y1 + y2) / 2} H${x} V${y2 - 9}`;
        pts = `${x - 8},${y2 + 0.5} ${x + 8},${y2 + 0.5} ${x},${y2 - 9}`;
      } else {
        /* 下の札が右にある（タブレット・PC）：左辺に左向きの三角 */
        const x2 = C.left - ox;
        const yl = Math.min(y1 + 14, C.bottom - oy - 24);
        d = `M${x1} ${y1} V${yl} H${x2 - 9}`;
        pts = `${x2 + 0.5},${yl - 8} ${x2 + 0.5},${yl + 8} ${x2 - 9},${yl}`;
      }
      path.setAttribute('d', d);
      path.setAttribute('stroke', tone);
      tri.setAttribute('points', pts);
      tri.setAttribute('fill', tone);
    };
    const redraw = () => { draw(); setTimeout(draw, 600); };
    let rt;
    window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(draw, 150); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(draw);

    const select = (tag, focus) => {
      tags.forEach((t) => {
        const on = t === tag;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });
      const id = tag.getAttribute('aria-controls');
      cards.forEach((c) => {
        const on = c.id === id;
        c.classList.toggle('is-on', on);
        c.toggleAttribute('inert', !on);
      });
      if (focus) tag.focus();
      redraw();
    };
    tags.forEach((t, i) => {
      t.addEventListener('click', () => { touched = true; select(t); });
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        const n = tags[(i + (e.key === 'ArrowRight' ? 1 : tags.length - 1)) % tags.length];
        touched = true;
        select(n, true);
      });
    });
    select(tags.find((t) => t.classList.contains('is-on')) || tags[0]);

    if (reduce || !('IntersectionObserver' in window)) { draw(); svg.classList.add('is-on'); return; }
    sec.classList.add('is-armed');
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      sec.classList.add('is-in');
      /* 札が掛かり終わったら線を出し、選ばれていない札を1回だけ揺らす */
      setTimeout(() => { draw(); svg.classList.add('is-on'); }, 1250);
      setTimeout(() => {
        if (touched) return;
        const other = tags.find((t) => !t.classList.contains('is-on'));
        if (!other) return;
        other.classList.add('is-nudge');
        other.addEventListener('animationend', () => other.classList.remove('is-nudge'), { once: true });
      }, 1700);
    }), { threshold: .4, rootMargin: '0px 0px -8% 0px' });
    io.observe(sec.querySelector('.ks8__menu'));
  };
  const run = () => document.querySelectorAll('.ks8').forEach((s) => { if (s.querySelector('[data-ks8-pick] .ks8__tag')) init(s); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
  document.addEventListener('shopify:section:load', run);
})();
